var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){return _vm.dropdownToggle()}}},[_c('router-link',{staticClass:"navbar-item flex-horizontal",attrs:{"to":{ path: ("/" + _vm.path) }}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }